import React, { useEffect } from "react";
import Body from "@appsinti/stats-frontend/home/components/Body";
import { useData } from "../../data";
import LineChart from "../../components/charts/line";
import BarChart from "../../components/charts/bar";
import IChartData from "../../../interfaces/IChartData";

const Cancellations: React.FC = () => {
  const { cancellations, fetchCancellations } = useData();

  useEffect(() => {
    fetchCancellations();
  }, []);

  return (
    <Body>
      {cancellations?.map((graph: IChartData | null, index: React.Key | null | undefined) => {
        if (!graph) return null;
        if (graph.type === "line") {
          return (
            <LineChart
              key={index}
              dataObject={graph}
            />
          );
        }

        if (graph.type === "bar") {
          return (
            <BarChart
              key={index}
              dataObject={graph}
            />
          );
        }
        return null;
      })}
    </Body>
  );
};
export default Cancellations;
